import { handle } from './togglable.js'

const handler = ({ checked }, fieldset) => {
  fieldset.disabled = !checked
}

export default toggler => {
  handle(toggler, handler)
}
